import { useShippingOptionsAction } from '../hooks/useCheckoutAction'
import { ActionProgress, Icon } from '@ztechapps/webui.util'
import { OrderCheckoutActivePanelEnum } from '@ztechapps/order.common'
import React from 'react'

export const ShippingOptionsActionProgressStep = () => {
  const [onClickShippingOptions] = useShippingOptionsAction()

  return (
    <ActionProgress.Step stepKey={OrderCheckoutActivePanelEnum.shippingOptions} onClick={onClickShippingOptions}>
      <Icon name="truck" /> Shipping Option
    </ActionProgress.Step>
  )
}
